<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col lg:flex-row lg:justify-center items-center px-6 lg:px-0 pt-10 pb-12 lg:py-10 col-span-full md:col-start-2 md:col-end-8 lg:col-end-12 gap-x-14 gap-y-16"
    >
      <section class="w-full lg:w-1/2 max-w-133.25">
        <p
          class="text-14 lg:text-extrabig leading-16.25 lg:leading-20.25"
          v-text="'Agregar título de banner segun la Temática'"
        />
        <section class="flex items-center pt-16">
            <section class="mr-11 lg:mr-36">
                <div class="bg-gray-400 h-40-px w-10 rounded-xl" />
                <p class="pt-4 uppercase font-bold text-xl" v-text="'19 DE FEBRERO'"/>
                <p class="uppercase font-semibold text-sm" v-text="'DOMINGO'"/>
            </section>
            <section>
                <div class="bg-gray-400 h-40-px w-10 rounded-xl" />
                <p class="pt-4 uppercase font-bold text-xl" v-text="'10:26'"/>
                <p class="uppercase font-semibold text-sm" v-text="'HORA DEL PACÍFICO'"/>
            </section>
        </section>
      </section>

      <section class="w-full lg:w-1/2 max-w-109 border-2 border-black">
        <section class="border-b border-black py-4">
          <p
            class="text-center text-3xl font-semibold"
            v-text="'Regístrate gratis'"
          />
        </section>
        <section class="p-20-px">
          <section class="flex flex-col pb-20-px gap-y-2.5">
            <input-field
              identity="firstName"
              ref="firstName"
              placeholder="Nombre"
              v-model="contactData.firstName"
              :rules="{
                required: true,
              }"
            />
            <input-field
              identity="lastName"
              ref="lastName"
              placeholder="Apellidos"
              v-model="contactData.lastName"
              :rules="{
                required: true,
              }"
            />
            <input-field
              identity="phone"
              ref="phone"
              placeholder="Teléfono"
              v-model="contactData.phone"
              :rules="{
                required: true,
                numeric: true,
              }"
            />
            <input-field
              identity="email"
              ref="email"
              placeholder="Correo electrónico"
              v-model="contactData.email"
              :rules="{
                required: true,
                email: true,
              }"
            />
          </section>
          <section class="flex justify-center">
            <main-button />
          </section>
          <p class="text-sm pt-2.5" v-text="'Lorem Ipsum is simply dummy text of the printing and types etting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s'"/>
        </section>
      </section>
    </section>
  </section>
</template>
<script>
export default {
  components: {
    InputField: () => import("../components/InputField.vue"),
    MainButton: () => import("../components/MainButton.vue")
  },
  data: () => ({
    contactData: {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
    },
  }),
  props:{
    withBorder:{
      default: true
    }
  }
};
</script>
